import { useEffect } from 'react';
import { AppNavLinks } from './app-nav-links';
import { getNavSections } from './nav-items';
import { useAuth } from '../hooks/useAuth';
import { authDebug } from '../lib/auth-debug';
import { AppBrand } from '../components/ui/app-brand';

export function AppSidebar() {
  const { userDoc } = useAuth();
  const sections = getNavSections({
    isGlobalAdmin: userDoc?.isGlobalAdmin,
    isCondominiumManager: userDoc?.isCondominiumManager,
  });

  useEffect(() => {
    authDebug('Sidebar atualizada', {
      email: userDoc?.email,
      isGlobalAdmin: userDoc?.isGlobalAdmin,
      isCondominiumManager: userDoc?.isCondominiumManager,
      nav: sections.flatMap((section) => section.items.map((item) => item.to)),
    });
  }, [userDoc?.email, userDoc?.isGlobalAdmin, userDoc?.isCondominiumManager, sections]);

  return (
    <aside
      data-tour="sidebar-nav"
      className="hidden w-60 shrink-0 border-r border-separator bg-surface md:flex md:flex-col"
    >
      <div className="flex h-14 items-center border-b border-separator px-4">
        <AppBrand markClassName="size-9 rounded-lg" iconSize={20} />
      </div>
      <div className="p-3">
        <AppNavLinks sections={sections} />
      </div>
    </aside>
  );
}
